"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
var Notifications = /** @class */ (function () {
    function Notifications() {
        var _this = this;
        this.context = null;
        this.messages = null;
        this.init = function (context, data) {
            _this.context = context;
        };
        this.set = function (messages) { return (_this.messages = messages); };
        this.get = function (message) { return _this.messages[message]; };
    }
    return Notifications;
}());
exports.Notifications = Notifications;
//# sourceMappingURL=notifications.js.map